/**
 * Names of fields that can be rendered by the Update Member Credential Prompt Form Field component.
 */
export var UpdateMemberCredentialPromptFormFieldName;
(function (UpdateMemberCredentialPromptFormFieldName) {
    /**
     * Renders a field for the member's password.
     */
    UpdateMemberCredentialPromptFormFieldName["Password"] = "Password";
    /**
     * Renders a field for the member's email address.
     */
    UpdateMemberCredentialPromptFormFieldName["Email"] = "Email";
    /**
     * Renders a field for the member's username.
     */
    UpdateMemberCredentialPromptFormFieldName["Username"] = "Username";
})(UpdateMemberCredentialPromptFormFieldName || (UpdateMemberCredentialPromptFormFieldName = {}));
//# sourceMappingURL=field-name.js.map